export const DEFAULT_FILTERS = {sku: '', partner: '', q: '', stage: '', deadline: '', overdue_stage: ''}

// Các bộ lọc "thường" — loại trừ lẫn nhau với filter "Quá hạn công đoạn"
const COMMON_KEYS = ['sku', 'partner', 'q', 'stage', 'deadline']

// Quy tắc tương tác filter của FR-005/FR-006:
// - chọn "Quá hạn công đoạn" (≠ Tất cả) → xoá mọi bộ lọc thường (BR-6.1)
// - thao tác bất kỳ bộ lọc thường → "Quá hạn công đoạn" về "Tất cả" (BR-5.2)
// Trả {filters, clearedOthers}; clearedOthers = true khi thực sự có bộ lọc bị xoá (để báo người dùng)
export const applyFilterChange = (filters, change) => {
    const next = Object.assign({}, filters, change)

    if (change.overdue_stage) {
        COMMON_KEYS.forEach((key) => { next[key] = '' })
        return {filters: next, clearedOthers: COMMON_KEYS.some((key) => !!filters[key])}
    }

    if (COMMON_KEYS.some((key) => Object.prototype.hasOwnProperty.call(change, key))) {
        next.overdue_stage = ''
    }
    return {filters: next, clearedOthers: false}
}

// Bộ lọc chung gửi cho overview: không có mức hạn và overdue_stage (BR-1.3, BR-6.4)
export const getOverviewParams = (filters) => {
    const params = {}
    ;['sku', 'partner', 'q'].forEach((key) => { if (filters[key]) params[key] = filters[key] })
    return params
}

export const getItemsParams = (filters, extra) => {
    const params = {}
    Object.keys(filters).forEach((key) => { if (filters[key]) params[key] = filters[key] })
    return Object.assign(params, extra)
}
